import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=3695299e&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=3695299e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695299e",
  null
  
)

export default component.exports